// extracted by mini-css-extract-plugin
module.exports = {"root":"ProjectListingModalContent_root__33BW6","sectionIconWrapper":"ProjectListingModalContent_sectionIconWrapper__FPyC9","longWord":"ProjectListingModalContent_longWord__2QrjY"};